import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect } from "@/mixins/index";
import { getAdvOriginList } from "@/api/dataAll/advOriginList";
export default {
  name: "advdeiliOriginData",
  mixins: [serchSelect],
  data: function data() {
    var _this = this;

    return {
      pickerOptions0: {
        disabledDate: function disabledDate(time) {
          if (_this.searchData.activation != "") {
            return time.getTime() > Date.now() || time.getTime() > _this.searchData.activation;
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      pickerOptions1: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < _this.searchData.operation || time.getTime() > Date.now();
        }
      },
      intReq: ['getCountrys'],
      value1: [],
      value2: [],
      searchData: {
        page: 1,
        state: '',
        ad_action: '',
        ext: '',
        activation_time: '',
        activation_endtime: ''
      },
      statusArr: [{
        value: "1",
        label: this.$t('startStatus')
      }, {
        value: "2",
        label: this.$t('completeStatus')
      }],
      num: "",
      show: false,
      tableData: [],
      totalshow: false,
      per_page: 5,
      total: 0,
      page: 1,
      more: true
    };
  },
  created: function created() {
    this.getsearchDate();
  },
  methods: {
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.value2[0] = date;
      this.value2[1] = date;
    },
    searchClick: function searchClick() {
      var _this2 = this;

      if (this.value2 && Array.isArray(this.value2) && this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      if (this.value1 && Array.isArray(this.value1) && this.value1.length > 0) {
        this.searchData.activation_time = this.value1[0];
        this.searchData.activation_endtime = this.value1[1];
      } else {
        this.searchData.activation_time = "";
        this.searchData.activation_endtime = "";
      }

      getAdvOriginList(this.searchData).then(function (res) {
        if (res.status == 200) {
          _this2.tableData = res.data.data || [];
          _this2.total = res.data.total || 0;
          _this2.page = res.data.current_page;
          _this2.per_page = res.data.per_page;
          _this2.show = true;
          _this2.totalshow = true;
        } else {
          _this2.$message({
            message: _this2.$t('requestDataError')
          });
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.searchClick();
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('idLabel'),
        prop: 'id'
      }, {
        label: this.$t('game'),
        prop: 'game'
      }, {
        label: this.$t('platform'),
        prop: 'platform'
      }, {
        label: this.$t('channel'),
        prop: 'channel'
      }, {
        label: this.$t('pkg'),
        prop: 'pkg'
      }, {
        label: this.$t('operation'),
        prop: 'ad_action'
      }, {
        label: this.$t('time'),
        prop: 'timestamp'
      }];
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};